class ExpandableBanner {
	constructor( $el ) {
		this.$el = {
			root: $el,
			toggle: $el.querySelector( '.js-home-banner-toggle' ),
			description: $el.querySelector( '.js-home-banner-description' ),
			hide: $el.querySelector( '.js-home-banner-hide' ),
			show: $el.querySelector( '.js-home-banner-show' ),
		};

		this.classNames = {
			collapsed: 'c-home-banner--collapsed',
			hide: 'd-none',
		};

		this.contentHeight = this.$el.description.offsetHeight;
		this.$el.description.style.height = `${ this.contentHeight }px`;

		this.bindEvents();
	}

	bindEvents() {
		this.$el.toggle.addEventListener( 'click', () => {
			if ( this.$el.toggle.getAttribute( 'aria-expanded' ) === 'true' ) {
				this.collapse();
			} else {
				this.expand();
			}
		} );
	}

	collapse() {
		this.$el.root.classList.add( this.classNames.collapsed );
		this.$el.toggle.setAttribute( 'aria-expanded', false );
		this.$el.hide.classList.add( this.classNames.hide );
		this.$el.show.classList.remove( this.classNames.hide );
		this.$el.description.style.height = 0;
	}

	expand() {
		this.$el.root.classList.remove( this.classNames.collapsed );
		this.$el.toggle.setAttribute( 'aria-expanded', true );
		this.$el.hide.classList.remove( this.classNames.hide );
		this.$el.show.classList.add( this.classNames.hide );
		this.$el.description.style.height = `${ this.contentHeight }px`;
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	const $banner = document.querySelectorAll( '.js-home-banner' );
	$banner.forEach( ( element ) => {
		new ExpandableBanner( element );
	} );
} );
